<template>
    <div class="container-box"
         v-loading="statusLoading||loading"
         element-loading-text="加载中...">
        <content-empty v-if="isOverMax==1" :type="2"/>
        <template v-else>
            <div class="search-area marginB20" v-if="searchList.length>0">
                筛选：
                <div class="search-area-item"
                     v-for="(item, index) in searchList"
                     :key="index"
                >
                    <el-select v-model="selectQueryObj[item]"
                               :placeholder="'全部'+item"
                               filterable
                               @change="val=>onChange(val,item,searchList[index+1])">
                        <el-option :label="'全部'+item"
                                   :value="''"
                        ></el-option>
                        <el-option v-for="(item2, index2) in selectListObj[item]"
                                   :key="index2"
                                   :label="item2"
                                   :value="item2.toString()"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <div class="content-area">
                <div class="content-table">
                    <el-row :gutter="20">
                        <el-col :span="24"
                                :lg="12"
                                :xl="8"
                                v-for="(item, index) in tableData"
                                :key="index"
                        >
                            <div class="monitor-box">
                                <div class="monitor-box-header">
                                    {{item.key}}
                                </div>
                                <div class="monitor-box-show">
                                    <div class="monitor-box-show-box">
                                        <div class="monitor-box-show-item"
                                             v-for="(item2, index2) in item.studentList"
                                             :key="index2"
                                        >
                                            <el-tooltip placement="top" effect="light">
                                                <div slot="content">
                                                    <div v-if="item2.name">姓名：{{item2.name}}</div>
                                                    <div v-if="item2.idCard">证件号：{{item2.idCard}}</div>
                                                    <div v-if="item2.code">扫码号：{{item2.code}}</div>
                                                    <div v-if="item2.sort">序号：{{item2.sort}}</div>
                                                </div>
                                                <div :class="{
                                                    'monitor-box-show-item-box':true,
                                                    'color_1': checkStatus(item2.isPass,item2.isPolicy)==2,
                                                    'color_2': checkStatus(item2.isPass,item2.isPolicy)==3,
                                                    'color_3': checkStatus(item2.isPass,item2.isPolicy)==1,
                                                }"></div>
                                            </el-tooltip>
                                        </div>
                                    </div>

                                </div>
                                <div class="monitor-box-bottom">
                                    <div class="num-area">
                                        <div>总人数：{{item.allNumbers}}</div>
                                    </div>
                                    <div class="num-area">

                                        <div class="cursor-div" @click="onView(item.jsonKey, '未识别', 1)">
                                            未识别：{{item.waitCheck}}
                                        </div>
                                    </div>
                                    <div class="num-area">
                                        <div class="cursor-div" @click="onView(item.jsonKey, '未通过', 2)">
                                            未通过：{{item.rejectNumber}}
                                        </div>
                                    </div>
                                    <div class="num-area">
                                        <div class="cursor-div" @click="onView(item.jsonKey, '通过1', 3)">
                                            通过1：{{item.onePassNumber}}
                                        </div>
                                    </div>
                                    <div class="num-area">
                                        <div class="cursor-div" @click="onView(item.jsonKey, '通过2', 4)">
                                            通过2：{{item.passNumber}}
                                        </div>
                                    </div>
                                    <!--<div class="btn-area" @click="onView(item.jsonKey)">查看</div>-->
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <el-pagination
                        class="content-pagination"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryParams.pageNum"
                        :page-size="queryParams.pageSize"
                        :page-sizes="[6, 12, 24, 48, 120]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background>
                </el-pagination>
            </div>
        </template>

        <!--查看监控表格数据弹框-->
        <show-table-monitor
                :titleFu="titleFu"
                :statusFu="statusFu"
                :jsonKeyFu="jsonKeyFu"
                :dialogVisibleFu="dialogVisibleFu"
                @closeDialog="closeDialog"
        />
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import ContentEmpty from "../../components/ContentEmpty";
    import ShowTableMonitor from "../../components/ShowTableMonitor";
    import {LevelSelect, GetMonitorList, GetMonitorStatus} from "../../request/record";

    export default {
        name: "record-monitor",
        components: {ContentEmpty, ShowTableMonitor},
        data() {
            return {
                loading: false,
                statusLoading: false,
                queryParams: {
                    pageNum: 1,
                    pageSize: 6,
                },
                total: 0,
                tableData: [],
                searchList: [],// 当前select显示的层级列表
                selectQueryObj: {}, // 所有select-绑定值的对象
                selectListObj: {},// 所有select列表的对象
                isOverMax: 0, // 1-超过100
                timer: null,
                titleFu: null,
                statusFu: null,
                jsonKeyFu: {},
                dialogVisibleFu: false, // 控制查看监控表格数据弹框显示与隐藏
            }
        },
        created() {
            this.getSearchList();
        },
        methods: {
            // 检录、公安状态-显示颜色
            checkStatus(isPass, isPolicy) {
                // 0-白色 1-深绿色 2-浅绿色 3-红色
                if (isPass == 0 && isPolicy == 0) {
                    return 0;
                } else if (isPass == 1 && isPolicy == 1) {
                    return 1;
                } else if (isPass == 1 || isPolicy == 1) {
                    return 2;
                }
                return 3;
            },
            // 获取当前最小区域层级所包含人数是否超过100人
            async getMonitorStatus() {
                let that = this;
                if (that.statusLoading) {
                    return false;
                }
                that.statusLoading = true;
                let res = await GetMonitorStatus({
                    projectId: that.getUserInfo.projectId,
                    uuid: that.getLink,
                })
                if (res.code != 200) {
                    that.$message.error(res.message);
                    that.statusLoading = false;
                    return true;
                }
                that.isOverMax = res.data.status;
                if (res.data.status == 1) {
                    that.statusLoading = false;
                    return true;
                }
                return false;
            },
            // 关闭查看未通过考生弹框
            closeDialog(val) {
                this.titleFu = null;
                this.statusFu = null;
                this.jsonKeyFu = {};
                this.dialogVisibleFu = val;
            },
            // 查看未通过考生按钮
            onView(jsonKey, key, status) {
                this.titleFu = key;
                this.statusFu = status;
                this.jsonKeyFu = jsonKey;
                this.dialogVisibleFu = true;
            },
            // select框-change事件
            onChange(value, name, next = '') {
                this.queryParams['pageNum'] = 1;
                localStorage.setItem('local_search_monitor_' + name, value);
                if (next) {
                    this.selectListObj[next] = this.getSelectList(name, next, value);
                }
                this.getList();
                this.$forceUpdate();
            },
            // 获取select框下拉列表
            async getSelectListReq(name, next = '', value = '') {
                let obj = {
                    projectId: this.getUserInfo.projectId,
                    name: name,
                    next: next,
                    value: value,
                }
                let res = await LevelSelect(obj);
                return res.data;
            },
            // 获取select框下拉列表，置空低等级的select绑定值和下拉列表
            async getSelectList(name, next, value) {
                let arr = this.dealArrQueen(this.searchList, name);
                arr.forEach(item => {
                    this.selectQueryObj[item] = '';
                    this.selectListObj[item] = [];
                    localStorage.setItem('local_search_monitor_' + item, '');
                })
                if (!value) return false;
                this.selectListObj[next] = await this.getSelectListReq(name, next, value);
            },
            // 获取筛选框数据
            async getSearchList() {
                let that = this;
                let status = await that.getMonitorStatus();
                if (status) {
                    return false;
                }
                that.queryParams['pageNum'] = 1;
                let tierList = that.getTierList;
                that.searchList = tierList;
                let selectQueryObj = {};
                let selectListObj = {};
                if (tierList.length > 0) {
                    selectListObj[tierList[0]] = await that.getSelectListReq(tierList[0]);
                    for (let i = 0; i < tierList.length; i++) {
                        let name = tierList[i],
                            next = tierList[i + 1];
                        let local = localStorage.getItem('local_search_monitor_' + name);
                        if (local) {
                            selectQueryObj[name] = local;
                            if (next) {
                                selectListObj[next] = await that.getSelectListReq(name, next, local);
                            }
                        } else {
                            selectQueryObj[name] = '';
                            if (next) {
                                selectListObj[next] = [];
                            }
                        }
                    }
                }
                that.selectQueryObj = selectQueryObj;
                that.selectListObj = selectListObj;
                that.getList();
            },
            // 处理数组-取数组arr中value之后（不包含value）的项，形成新数组
            dealArrQueen(arr, value) {
                const index = arr.indexOf(value);
                if (index === -1) return arr; // 如果值不存在，返回所有
                return arr.slice(index + 1, arr.length);
            },
            getList(type = true) {
                // type false-定时器无需loading
                let that = this;
                if (type) {
                    if (that.loading) {
                        return false;
                    }
                    that.loading = true;
                }
                that.statusLoading = false;
                that.timer && clearInterval(that.timer);
                let queryList = [];
                let searchList = that.searchList;
                let selectQueryObj = that.selectQueryObj;
                searchList.forEach(item => {
                    let obj = {};
                    obj[item] = selectQueryObj[item]
                    queryList.push(obj)
                })
                GetMonitorList({
                    projectId: that.getUserInfo.projectId,
                    eventCount: that.getSession,
                    uuid: that.getLink,
                    condition: queryList,
                    ...that.queryParams
                }).then((res) => {
                    // console.log(res, 'getList')
                    if (res.code != 200) {
                        that.loading = false;
                        return that.$message.error(res.message);
                    }
                    that.tableData = res.data.list;
                    that.total = res.data.total;
                    that.loading = false;
                    that.timer = setInterval(() => {
                        that.getList(false);
                    }, 10000)
                })
                    .catch((err) => {
                        // console.log(err);
                        that.loading = false;
                    });
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.queryParams.pageSize = val;
                this.queryParams.pageNum = 1;
                this.getList();
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.queryParams.pageNum = val;
                this.getList();
            }
        },
        computed: {
            ...mapGetters([
                'getUserInfo',
                'getSession',
                'getLink',
                'getTier',
                'getLinkList',
                'getTierList',
            ])
        },
        watch: {
            getSession(val) {
                // console.log(val, 'getSession');
                this.getList();
            },
            getLink(val) {
                // console.log(val, 'getLink');
                this.getSearchList();
            },
            getLinkList(val) {
                // console.log(val, 'getLinkList');
                this.getSearchList();
            },
        },
        beforeDestroy() {
            let that = this;
            that.timer && clearInterval(that.timer);
        },
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/common";
</style>

